import { render, staticRenderFns } from "./model-registeredUser.vue?vue&type=template&id=0b713d2a&scoped=true&"
import script from "./model-registeredUser.vue?vue&type=script&lang=js&"
export * from "./model-registeredUser.vue?vue&type=script&lang=js&"
import style0 from "./model-registeredUser.vue?vue&type=style&index=0&id=0b713d2a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b713d2a",
  null
  
)

export default component.exports